import { useWidgets } from "../../common/WidgetsProvider";

export default function TopEvents(props) {
    const widgetsData = useWidgets();

    if (widgetsData == null) {
        return null;
    }

    return props.renderItem(widgetsData.topMatches);
}
